import { render, staticRenderFns } from "./IconCheckbox.vue?vue&type=template&id=2e5fd168&scoped=true&"
import script from "./IconCheckbox.vue?vue&type=script&lang=js&"
export * from "./IconCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5fd168",
  null
  
)

export default component.exports